export default {
  startingPitchers: {
    title: "Starting Pitcher",
    tabs: {
      byPitcher: "Nach Pitcher",
      allPitchers: "Alle Pitcher",
    },
    labels: {
      confirmed: "BESTÄTIGT",
      expected: "ERWARTET",
      pitcher: "PITCHER",
      tbd: "OFFEN",
    },
    empty: {
      title: "Keine Starting Pitcher verfügbar",
    },
  },
};
